/**
 * Shared color-ramp and test ID utilities for the intensity scale components.
 *
 * Pattern: all test IDs are generated via named setter functions so component
 * and tests can never drift apart.
 */

import { generateTestId } from "@client-shared";
import type { IntensityPosition } from "@shared/types/intensity";

export const setIntensityConfidenceBadgeTestId = (identifier: string | number): string =>
  generateTestId("IntensityScale", "confidence-badge", identifier);

/**
 * Roast-colour ramp for the nine positions, lightest first. Applied as an inline
 * background so the exact ramp survives a Tailwind production purge — arbitrary
 * colour values built at runtime would not.
 */
export const INTENSITY_BLOCK_COLORS: Readonly<Record<IntensityPosition, string>> = {
  1: "#EBD9C9",
  2: "#DFBBA6",
  3: "#CE9C74",
  4: "#C08A44",
  5: "#8F6039",
  6: "#74482C",
  7: "#5A3722",
  8: "#43291A",
  9: "#2B1A11",
};

/** Positions 5 and darker need light text to stay legible on the brown. */
export const intensityBlockTextClass = (position: IntensityPosition): string => (position >= 5 ? "text-white" : "text-neutral-900");
